import React from 'react';
import { Plus, Trash2, ChevronUp, ChevronDown } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';

const move = (arr, from, to) => {
  if (to < 0 || to >= arr.length) return arr;
  const next = [...arr];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
};

// fields: [{ key, placeholder, multiline?, className? }]; items may be strings when fields is a single key 'value'
export const ListEditor = ({ items = [], onChange, fields, addLabel = 'Add', testId, blank }) => {
  const isString = fields.length === 1 && fields[0].key === 'value' && typeof blank === 'string';
  const read = (item, key) => (isString ? item : item?.[key] || '');
  const write = (i, key, val) => onChange(items.map((it, idx) => (idx !== i ? it : isString ? val : { ...it, [key]: val })));

  return (
    <div className="space-y-2" data-testid={`${testId}-list`}>
      {items.map((item, i) => (
        <div key={i} data-testid={`${testId}-row-${i}`} className="flex gap-2 items-start bg-slate-50 border border-slate-200 rounded-lg p-2">
          <div className="flex flex-col">
            <button type="button" aria-label="Move up" data-testid={`${testId}-up-${i}`} onClick={() => onChange(move(items, i, i - 1))} className="text-slate-400 hover:text-slate-900 disabled:opacity-30" disabled={i === 0}><ChevronUp className="h-4 w-4" /></button>
            <button type="button" aria-label="Move down" data-testid={`${testId}-down-${i}`} onClick={() => onChange(move(items, i, i + 1))} className="text-slate-400 hover:text-slate-900 disabled:opacity-30" disabled={i === items.length - 1}><ChevronDown className="h-4 w-4" /></button>
          </div>
          <div className="flex-1 grid gap-2 md:grid-cols-[1fr_2fr]">
            {fields.map((f) => f.multiline ? (
              <Textarea key={f.key} data-testid={`${testId}-${f.key}-${i}`} rows={2} value={read(item, f.key)} placeholder={f.placeholder} className={f.className} onChange={(e) => write(i, f.key, e.target.value)} />
            ) : (
              <Input key={f.key} data-testid={`${testId}-${f.key}-${i}`} value={read(item, f.key)} placeholder={f.placeholder} className={f.className} onChange={(e) => write(i, f.key, e.target.value)} />
            ))}
          </div>
          <button type="button" aria-label="Remove" data-testid={`${testId}-remove-${i}`} onClick={() => onChange(items.filter((_, idx) => idx !== i))} className="text-slate-400 hover:text-red-600 mt-2"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <Button type="button" data-testid={`${testId}-add`} variant="outline" size="sm" onClick={() => onChange([...items, isString ? '' : { ...blank }])}>
        <Plus className="h-4 w-4 mr-1" />{addLabel}
      </Button>
    </div>
  );
};
